import axios from 'axios';
import SetupBackEnd from './config/config.js';

const url = axios.create({
    baseURL: 'https://viacep.com.br/ws/'
});

function searchZipcode(data) {
    return url.get(data + '/json');
}

function searchWolrdZipcode(data) {
    return SetupBackEnd.post('/world-zipcode', data);
}

const ZipcodeServices = {
    searchZipcode,
    searchWolrdZipcode,
}

export default ZipcodeServices;
